module.exports = __webpack_public_path__ + "static/media/send-right-icon.b9e534ef.svg";